<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import ChartEnergyEfficiency from '$lib/PageSections/Charts/ChartEnergyEfficiency/ChartEnergyEfficiency.svelte';
	import CustomerStory from '$lib/PageSections/CustomerStory/CustomerStory.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import EnergyInAction from '$lib/PageSections/IndowInAction/EnergyInAction.svelte';
	import ProductRecommendation from '$lib/PageSections/Products/ProductRecommendation.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import TrustedChoice from '$lib/PageSections/TrustedChoice/TrustedChoice.svelte';

	import windowCondensation from './images/windowCondensation.jpg';

	import { ThermalProduct } from '$lib/data/products/products-data.js';
	import { comfortCustomerStory } from '$routes/(public)/resources/case-studies/customer-stories.js';
</script>

<Section>
	<h2 class="text-left">Dealing With Moisture Around Your Windows?</h2>
	<p class="text-left">
		Windows (even double paned) are notoriously bad insulators, which leads to
		condensation forming when the warm air of your home meets the cold glass of
		your windows. Over time, this can lead to water damage - particularly on
		wood frames and plaster - and can even lead to mold and mildew growth.
	</p>

	<Image src={windowCondensation} loading="eager" />

	<h2 class="text-left">Stop Condensation with Indow Thermal Inserts</h2>

	<p class="text-left">
		With our patented Snug Fit compression tubing and premium acrylic glazing,
		our <a href="/products/thermal-window-inserts">Thermal Window Inserts</a> reduces
		the amount of cold drafts and heat loss happening through your windows. This leads
		to lower energy use - saving homeowners an average of 20% per year on energy expenses
		- it also drastically reduces condensation by creating a barrier between the cold
		winter air and your warm, cozy home.
	</p>
	<p class="text-left">
		But the best part? They blend in with your existing window frames and let
		light flow in freely. In fact, if it wasn't for how much warmer and drier
		they make your windows - you'd forget they were there!
	</p>
	<EnergyInAction />
</Section>

<CustomerStory story={comfortCustomerStory} />

<Section>
	<h2 class="text-left">More Quiet, More Comfort, More Savings</h2>
	<p class="text-left">
		In addition to preventing condensation and reducing temperature loss, Indow
		Thermal Inserts also provide significant noise reduction, keeping your home
		up to 50% quieter. It's a win-win-win for your pocket book, the planet, and
		your day-to-day comfort.
	</p>
	<p class="text-left">
		Our air-tight seal not only keeps noise out and your ideal temperature in,
		but it also reduces condensation and
		<a href="/solutions/block-pollen-and-pollutants"
			>blocks dust, pollen, and other airborne particles</a
		>. But that doesn't mean you'll have to live in a hermetically sealed home!
		With a gentle tug on the provided D-ring, you can break the seal and remove
		the inserts whenever you want to open your windows and let in some fresh
		air.
	</p>
</Section>

<ProductRecommendation product={ThermalProduct} />

<Section backgroundColor="grey-light">
	<h3 class="text-indow-grey-dark">Indow vs Replacement Windows</h3>
	<p>
		Adding Indow inserts to an existing window can make your windows perform as
		well (or better!) than a replacement window, but at a fraction of the cost
		and without the hassle and disruption of installing new windows.
	</p>
	<ChartEnergyEfficiency />
</Section>

<TrustedChoice />
<Reviews />
<GetAFreeEstimate />
